module.exports = __webpack_public_path__ + "img/twitter.c271e899.svg";